var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-flow"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title-section"},[_vm._v(_vm._s(_vm.webInfo.webName)+"平台全流程亮点")]),_vm._v(" "),_c('img',{staticClass:"img-flow",attrs:{"src":_vm.webInfo.home.ptlc,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }